import React from 'react';
import { string } from 'prop-types';

import { Icon, Link } from '../index';

import './back-link.scss';

const BackLink = ({ href }) => (
    <span className="back-link">
        <Icon type="chevron-l" />
        <Link text="Back" href={href} />
    </span>
);

BackLink.propTypes = {
    href: string.isRequired
};

export default BackLink;
